/*
 * Inspinia js helpers:
 *
 * correctHeight() - fix the height of main wrapper
 * detectBody() - detect windows size
 * smoothlyMenu() - add smooth fade in/out on navigation show/hide
 *
 */

declare var jQuery: any;

export function correctHeight() {
  let pageWrapper = jQuery('#page-wrapper');
  let navbarHeight = jQuery('nav.navbar-default').height();
  let wrapperHeigh = pageWrapper.height();

  if (navbarHeight > wrapperHeigh) {
    pageWrapper.css('min-height', navbarHeight + 'px');
  }

  if (navbarHeight < wrapperHeigh) {
    if (navbarHeight < jQuery(window).height()) {
      pageWrapper.css('min-height', jQuery(window).height() + 'px');
    } else {
      pageWrapper.css('min-height', navbarHeight + 'px');
    }
  }

  if (jQuery('body').hasClass('fixed-nav')) {
    if (navbarHeight > wrapperHeigh) {
      pageWrapper.css('min-height', navbarHeight + 'px');
    } else {
      pageWrapper.css('min-height', jQuery(window).height() - 60 + 'px');
    }
  }
}

export function detectBody() {
  if (jQuery(document).width() < 769) {
    jQuery('body').addClass('body-small');
  } else if (jQuery(document).width() > 1169) {
    jQuery('body').removeClass('mini-navbar');
    jQuery('body').removeClass('body-small');
  } else {
    jQuery('body').removeClass('body-small');
    jQuery('body').addClass('mini-navbar');
  }
}

export function smoothlyMenu() {
  if (
    !jQuery('body').hasClass('mini-navbar') ||
    jQuery('body').hasClass('body-small')
  ) {
    // Hide menu in order to smoothly turn on when maximize menu
    jQuery('#side-menu').hide();
    // For smoothly turn on menu
    setTimeout(function () {
      jQuery('#side-menu').fadeIn(400);
    }, 200);
  } else if (jQuery('body').hasClass('fixed-sidebar')) {
    jQuery('#side-menu').hide();
    setTimeout(function () {
      jQuery('#side-menu').fadeIn(400);
    }, 100);
  } else {
    // Remove all inline style from jquery fadeIn function to reset menu state
    jQuery('#side-menu').removeAttr('style');
  }
}

let focusableElementsString =
  'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';

export function setFocusToFirstItemInModal(obj) {
  // get list of all children elements in given object
  if (obj && obj.find) {
    let o = obj.find('*');

    // set the focus to the first keyboard focusable item
    let focusElement = o
      .filter(focusableElementsString)
      .filter(':visible')
      .first();
    consoleLog('Elemento para el foco:');
    consoleLog(focusElement);
    focusElement.focus();
  }
}

export function configureModalFocusTrap() {
  consoleLog('app *********************************************');
  // attach a listener to redirect the tab to the modal window
  // if the user somehow gets out of the modal window

  jQuery('body').on('focusin', function (event) {
    consoleLog(event);
    consoleLog(jQuery(this));

    // Si está activa la capa de espera
    let wc = document.getElementById('wcId');
    if (wc) {
      waitComponentFocusControl(wc);
    } else {
      let v1 = jQuery('#wrapper').find('p-confirmdialog > div');
      consoleLog(v1);
      if (v1.length) {
        consoleLog('Hay ' + v1.length + ' p-confirmdialog');
        focusControl(event, 'p-confirmdialog', v1);
      } else {
        consoleLog('No hay p-confirmdialog');

        let v2 = jQuery('#wrapper').find('p-dialog');
        if (v2.length) {
          consoleLog('Hay ' + v2.length + ' p-dialog');
          focusControl(event, 'p-dialog', v2[v2.length - 1]);
        } else {
          consoleLog('No hay p-dialog dentro del wrapper');
          consoleLog(v2);

          let vv = jQuery('p-dynamicdialog').find('p-dialog');
          if (vv.length) {
            consoleLog('Hay ' + vv.length + ' p-dialog dentro de p-dynamicdialog');
            focusControl(event, 'p-dialog', vv[vv.length - 1]);
          } else {
            consoleLog('No hay p-dialog dentro de p-dynamicdialog');

            consoleLog(vv);

            let v3 = jQuery('body')
              .find('p-dynamicdialog')
              .last();
            if (v3.length) {
              consoleLog('Hay ' + v3.length + ' p-dynamicdialog');
              focusControl(event, 'p-dynamicdialog', v3);
            } else {
              consoleLog('No hay p-dynamicdialog');
            }
            consoleLog(v3);

          }
        }

      }
    }
  });
  consoleLog('app *********************************************');
}

export function focusControl(event, dialogTag, obj) {
  consoleLog(dialogTag + '*********************************************');

  consoleLog('Elemento enfocado:');
  consoleLog(event.target);
  consoleLog(jQuery(event.target).parents());
  // Los multiselect están en el DOM fuera del los diálogos, a nivel raíz
  if (
    jQuery(event.target).hasClass('p-inputtext') &&
    jQuery(event.target).hasClass('p-component') &&
    jQuery(event.target).hasClass('p-state-default') &&
    jQuery(event.target.parentNode).hasClass('p-multiselect-filter-container')
  ) {
    consoleLog('Es un multislect, por lo que ...');

    consoleLog('el foco dentro de la modal');
  } else {
    let inModalDialog = jQuery(event.target)
      .parents()
      .filter(dialogTag);

    consoleLog(inModalDialog);
    if (inModalDialog.length > 0) {
      consoleLog('Foco dentro de la modal');
    } else {
      consoleLog('Foco FUERA de la modal');
      setFocusToFirstItemInModal(obj);
    }
    consoleLog(dialogTag + ' *********************************************');
  }
}

export function waitComponentFocusControl(wc) {
  document.getElementById('foco').focus();
  //wc.focus();
  //setFocusToFirstItemInModal(jQuery('wcId'));
}

export function consoleLog(txt: any) {
  let log = false;
  if (log) {
    console.log(txt);
  }
}




export function clearModalsOnCloseSession() {
  consoleLog('app *********************************************');

  let v1 = jQuery('#wrapper').find('p-confirmdialog > div');
  consoleLog(v1);
  if (v1.length) {
    consoleLog('Hay ' + v1.length + ' p-confirmdialog');
    jQuery(v1).remove();
  }
  let v2 = jQuery('#wrapper').find('p-dialog');
  if (v2.length) {
    consoleLog('Hay ' + v2.length + ' p-dialog');
    jQuery(v2).remove();
  }

  let vv = jQuery('p-dynamicdialog').find('p-dialog');
  if (vv.length) {
    consoleLog('Hay ' + vv.length + ' p-dialog dentro de p-dynamicdialog');
    jQuery(vv).remove();
  }

  let v3 = jQuery('body')
    .find('p-dynamicdialog')
    .last();
  if (v3.length) {
    consoleLog('Hay ' + v3.length + ' p-dynamicdialog');
    jQuery(v3).remove();
  }
  let ovp = jQuery('body')
    .find('p-overlaypanel')
    .last();
  if (ovp.length) {
    consoleLog('Hay ' + ovp.length + ' p-overlaypanel');
    jQuery(ovp).remove();
  }




}
